module.exports = __webpack_public_path__ + "2833f86de58fb3df4c141860d1b2322f.svg";